import React, { useEffect, useRef, useState } from 'react'
import BGModal from '../../assets/modalBG.svg'
import IconTerminer from '../../assets/statusTerminer.svg'
import IconInProgress from '../../assets/statusInProgress.svg'
import IconInAnnuler from '../../assets/statusAnnule.svg'
interface Props {
  isOpen: boolean
  closeModal: () => void
  beneficiaire: string
  montantEnvoye: string
  montantRecevoir?:string
  currency?:string
  pointsCollecte?: string
  date: string
  taux?:string
  frais?:string
  status?:string
  distributionChannel?:string
  codeRetrait?:string
  titreModal: string
  bgBlur?:string

}

const ModalHistoryTransfert: React.FC<Props> = ({
  isOpen,
  closeModal,
  beneficiaire,
  montantEnvoye,
  montantRecevoir,
  currency,
  taux,
  frais=null,
  pointsCollecte,
  date,
  status,
  distributionChannel,
  codeRetrait, 
  titreModal,
  bgBlur='bg-[#5754E5]/90 opacity-10 backdrop-blur-[3px]'
}) => {
  if (!isOpen) return null

const [isOverflowing, setIsOverflowing] = useState(false)  
const [HeightInner, setHeightInner] = useState(window.innerHeight)  
  const containerRef= useRef<HTMLDivElement>(null)
  const contentRef= useRef<HTMLDivElement>(null)

  useEffect(()=>{
    const checkOverFlow=()=>{
    if(containerRef.current && contentRef.current){
      const containerHeight= containerRef.current.clientHeight
      const contentRefHeight = contentRef.current.scrollHeight
      setHeightInner(window.innerHeight)
      setIsOverflowing(containerHeight < contentRefHeight)
    }}
      checkOverFlow()

        window.addEventListener('resize', checkOverFlow)
        return()=>window.removeEventListener('resize', checkOverFlow)
    
  },[])
  return (
// ${ distributionChannel ==='cash_pickup' ? 'bg-[#5754E5]/35 opacity-10 backdrop-blur-[2px]' : bgBlur}
      // <div className='fixed inset-0 z-50 flex flex-col items-center justify-center '>
       <div className='fixed  flex flex-col justify-center place-items-center inset-0 z-50 bg-[rgba(87,84,229,0.2)] backdrop-blur-[5px]'
       >
        <div className={ ` 
        ${ distributionChannel ==='cash_pickup' ?' opacity-10' :distributionChannel ==='bank_account' && ' opacity-10' }
          fixed inset-0 `}
         style={{
            backgroundColor: 'rgba(87, 84, 229, 0.3)',
            backdropFilter: 'blur(2px)',
            WebkitBackdropFilter: 'blur(6px)',
          }}
        ></div>

            <img className='-mb-[25px] z-50 ' 
            src={ status==='in progress' ? IconInProgress 
              : status==='complete' || status=== 'Complete' 
              ?IconTerminer
              :IconInAnnuler
            } 
            alt=''/>
            <img className='z-50 ' src={BGModal} width={327} height={78} alt=''/>

            <div className="flex flex-col z-50  bg-[#FFF] w-[327px] pb-[32px] pl-[24px] pr-[13px] items-center justify-center rounded-b-[32px] ">
              <div className=" text-[20px] text-center mb-5 font-bold text-[#1D3A70]">{titreModal}</div>
            <div ref={containerRef} className= {`${HeightInner< 600 ? 'h-[200px]' : 'h-full '} w-full overflow-y-hidden `}>
              <div ref={contentRef} className={` ${isOverflowing ? 'scrollbar-webkit  pr-[13px]' : ' pr-[11px] scrollbar-hide'} flex overflow-y-scroll h-full flex-col gap-y-[25px]`}>
               

                <div className="flex items-center border-b justify-between">
                  <div className="text-[#6B7280] text-[15px]">Date d&apos;envoi </div>
                  <div className="  text-[#35258B] font-bold text-[16px] text-right">{date}</div>
                </div>

                {(distributionChannel ==='cash_pickup' || distributionChannel==='Recharge Mobile') &&
                 <div className="flex items-center border-b justify-between">
                  <div className="text-[#6B7280] text-[15px] w-full"> { distributionChannel==='Recharge Mobile' ? 'Opérateur' : 'Code de retrait'} </div>
                  <div className="  text-[#35258B] font-bold text-[16px] w-full text-right">
                    {codeRetrait ?
                        `${codeRetrait}`
                        :'En cours de traitement' }
                  </div>
                </div>}

                <div className="flex items-center border-b font-roboto justify-between">
                  <div className="text-[#6B7280] text-[15px]">Bénéficiaire </div>
                  <div className="  text-[#35258B] font-bold text-[16px] text-right"> {beneficiaire}</div>
                </div>

                <div className="flex items-center border-b">
                  <div className="text-[#6B7280] text-[15px]"> {distributionChannel ==='Recharge Mobile'  ? 'Montant payé' : 'Montant envoyé'} </div>
                  <div className="ml-auto pr-1 text-[#35258B] font-bold text-[16px] text-right">
                    {Number(montantEnvoye).toLocaleString('fr-FR', { 
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 3,})} €</div>
                </div>

                 <div className="flex items-center border-b font-roboto justify-between">
                  <div className="text-[#6B7280] text-[15px]">Montant reçu </div>
                  <div className=" text-[#35258B] font-bold text-[16px] text-right">{`
                  ${montantRecevoir ?
                   ` ${Number(montantRecevoir ).toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })}  ${currency}`
                  : '--'}`}
                   </div>
                </div>

               {(distributionChannel ==='cash_pickup' || distributionChannel ==='bank_account' ) &&
                <div className="flex items-center border-b font-roboto justify-between">
                  <div className="text-[#6B7280] text-[15px]">Frais </div>
                  <div className="  text-[#35258B] font-bold text-[16px] text-right">{frais} €</div>
                </div>
                }
                
               
                    
                {distributionChannel ==='cash_pickup' &&
                 <div className="flex items-center border-b font-roboto justify-between">
                  <div className="text-[#6B7280] text-[15px]">Point de collecte </div>
                  <div className=" text-[#35258B] font-bold text-[16px]  text-right">{pointsCollecte}</div>
                </div>}

              
              </div>
            </div>
               <button
                className="bg-[#4743C9] text-white font-bold text-[18px] w-[70%] rounded-xl py-3 mt-5"
                onClick={()=>{
                  closeModal()
                 
                }}
              >
                Ok
              </button>
            </div>
           
          </div>
      
  )
}

export default ModalHistoryTransfert
